import { IconButton as MIconButton, styled } from "@mui/material";

export const MainDiv = styled("div")(() => ({
  padding: "32px",
}));

export const ManageEmailSubscriptionsPageToolbar = styled("div")(() => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
}));

export const IconButton = styled(MIconButton)(() => ({
  padding: "8px",
}));

export const ModalText = styled("p")(() => ({
  color: "#232325",
  fontSize: 16,
  fontWeight: 400,
  lineHeight: "150%",
  fontFamily: "Manrope",
}));
